export const NO_FILTER_VALUE = 'NO_FILTER';
